import omit from 'lodash/omit'

export function trackEvent(eventData) {
  if (window.dataObject) {
    window.dataObject.time = Date()
    window.dataObject.url = window.location.href
    window.dataObject.event.push({
      ...eventData,
      page: eventData.page || window.location.pathname,
      url: eventData.url || window.location.href
    })
  }
}

export function trackQueryParam(paramName) {
  const url = new URL(window.location.href)
  const params = new URLSearchParams(url.search.slice(1))

  params.append(paramName, 'true')

  const href = window.location.origin + window.location.pathname + `?${params.toString()}`

  trackEvent({
    name: 'screenLoad',
    time: Date(),
    page: window.location.pathname + `?${params.toString()}`,
    url: href
  })

  if (window.dataObject) {
    window.dataObject.page = href
  }
}

export function untrackQueryParam(paramName) {
  const url = new URL(window.location.href)
  const params = new URLSearchParams(url.search.slice(1))
  if (!params.has(paramName)) return

  params.delete(paramName)

  const href = window.location.origin + window.location.pathname + `?${params.toString()}`

  trackEvent({
    name: 'screenLoad',
    time: Date(),
    page: window.location.pathname + `?${params.toString()}`,
    url: href
  })

  if (window.dataObject) {
    window.dataObject.page = href
  }
}

export function initGlassroom(w, d, s, l, i) {
  w[l] = w[l] || []
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
  var f = d.getElementsByTagName(s)[0]
  var j = d.createElement(s)
  var dl = l !== 'dataLayer' ? '&l=' + l : ''
  j.async = true
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
  f.parentNode.insertBefore(j, f)

  if (!window.dataLayer) window.dataLayer = []
}

export function initImpact(a, b, c, d, e, f, g) {
  const meow = function () {
    ;(e[c].a = e[c].a || []).push(arguments)
  }
  e['ire_o'] = c
  e[c] = e[c] || meow
  f = d.createElement(b)
  g = d.getElementsByTagName(b)[0]
  f.async = 1
  f.src = a
  g.parentNode.insertBefore(f, g)
}

export function getSessionID() {
  if (!window.sessionStorage.sid) {
    const sid = Math.random().toString(36).substr(2, 9)
    window.sessionStorage.sid = sid
  }
  return window.sessionStorage.sid
}

// A fast hashing function for browser JS
// https://stackoverflow.com/a/52171480/1297200
function cyrb53(str, seed = 0) {
  let h1 = 0xdeadbeef ^ seed,
    h2 = 0x41c6ce57 ^ seed
  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i)
    h1 = Math.imul(h1 ^ ch, 2654435761)
    h2 = Math.imul(h2 ^ ch, 1597334677)
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909)
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909)
  return 4294967296 * (2097151 & h2) + (h1 >>> 0)
}

export function getCheckoutHash(checkout) {
  const standardized = {
    ...checkout,
    productInfo: checkout.productInfo.map(pi => omit(pi, ['_helpers']))
  }

  return cyrb53(JSON.stringify(standardized))
}

export function getVariantAttributes({ variant, orderType } = {}) {
  if (!variant) return { color: null, frequency: null }
  const attributes = {
    ...variant.selectedOptions.reduce((acc, { name, value }) => ({ ...acc, [name.toLowerCase()]: value || null }), {})
  }
  if (orderType) attributes.orderType = orderType
  if (!attributes.color) attributes.color = null
  if (!attributes.frequency) attributes.frequency = null
  return attributes
}
